export default __webpack_public_path__ + "static/media/manzil_image4-mobile.png";